import { TicketsPage } from '@pages/Admin/ErrorTickets/pages/TicketsPage';

export const DashboardOtherTickets = () => {
  return <TicketsPage ticketType={5} />;
};
